import { Account, Admin, Campaign, Variant, ItemSize } from '@/types'

export type Status = 'unstarted' | 'started' | 'ended' | 'disabled'
type CampaignObject = Campaign | Account.Campaign | Admin.Campaign

export class Campaigns {
  static status (campaign: CampaignObject): Status {
    const now = new Date()

    if (campaign.disabledAt) {
      return 'disabled'
    } else if (now < new Date(campaign.startAt)) {
      return 'unstarted'
    } else if (new Date(campaign.endAt) < now) {
      return 'ended'
    } else {
      return 'started'
    }
  }

  static primarySize (campaign: CampaignObject): ItemSize {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return campaign.item.sizes.find(s => s.primary)!
  }

  static variant (campaign: CampaignObject, variantId: number): Variant | undefined {
    return campaign.variants.find(v => v.id === variantId)
  }
}
